/* eslint-disable react/prop-types */
import { useState, useEffect, useCallback } from "react";
// import { useParams, useNavigate } from "react-router-dom";
import { CheckCircle, Clock, Package, CreditCard, User, Hash } from "lucide-react";
import { useSearchParams } from "react-router-dom";

const OrderStatus = () => {
    const [searchParams] = useSearchParams();
    const transactionId = searchParams.get('transaction_id');
    const [transaction, setTransaction] = useState(null);

    const getTransactionDetail = useCallback(async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOST_INTELLIKASIR}/api/v1/transaction/trx-number/${transactionId}`);
            const res = await response.json();
            if (res.data) {
                setTransaction(res.data);
            } else {
                setTransaction(null);
            }
        } catch (error) {
            console.error("Error fetching transaction:", error);
            setTransaction(null);
        }
    }, [transactionId])

    useEffect(() => {
        if (transactionId) {
            getTransactionDetail();
        } else {
            setTransaction(null);
        }
    }, [getTransactionDetail, transactionId]);

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
            minimumFractionDigits: 0
        }).format(amount);
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'completed':
                return 'text-green-600 bg-green-100';
            case 'pending':
                return 'text-yellow-600 bg-yellow-100';
            case 'cancelled':
                return 'text-red-600 bg-red-100';
            default:
                return 'text-gray-600 bg-gray-100';
        }
    };

    const getStatusIcon = (status) => {
        switch (status) {
            case 'completed':
                return <CheckCircle className="w-5 h-5" />;
            case 'pending':
                return <Clock className="w-5 h-5" />;
            default:
                return <Package className="w-5 h-5" />;
        }
    };

    if (!transaction) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
                <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                    <p className="text-gray-600">Memuat detail transaksi...</p>
                </div>
            </div>
        );
    }


    console.log("transactionId==>>", transactionId)
    return (
        <div className="min-h-screen bg-white px-1">
            <div className="max-w-4xl mx-auto">
                {/* Header Card */}
                <div className="bg-white mb-6 overflow-hidden">
                    <div className="bg-[#1E5FA9] p-6 text-white">
                        <div className="flex items-center justify-between">
                            <div>
                                <h1 className="text-md font-bold mb-2">Status Pesanan</h1>
                                <div className="flex items-center gap-2 text-blue-100">
                                    <Hash className="w-4 h-4" />
                                    <span className="text-sm">{transaction.transaction_number}</span>
                                </div>
                            </div>
                        </div>

                        <div className={`flex items-center mt-5 gap-2 px-4 py-2 rounded-full ${getStatusColor(transaction.status)}`}>
                            {getStatusIcon(transaction.status)}
                            <span className="font-semibold capitalize">{transaction.status}</span>
                        </div>
                    </div>

                    <div className="p-6">
                        <div className="grid md:grid-cols-3 gap-6">
                            <div className="flex items-center gap-3">
                                <div className="bg-green-100 p-3 rounded-full">
                                    <CreditCard className="w-5 h-5 text-green-600" />
                                </div>
                                <div>
                                    <p className="text-sm text-gray-500">Metode Pembayaran</p>
                                    <p className="font-semibold">{transaction.payment_method}</p>
                                </div>
                            </div>

                            <div className="flex items-center gap-3">
                                <div className="bg-purple-100 p-3 rounded-full">
                                    <User className="w-5 h-5 text-purple-600" />
                                </div>
                                <div>
                                    <p className="text-sm text-gray-500">Nama</p>
                                    <p className="font-semibold">{transaction.user_name}</p>
                                </div>
                            </div>

                            <div className="border-t border-gray-200 pt-4">
                                <div className="flex justify-between items-center">
                                    <span className="text-xl font-bold text-gray-800">Total</span>
                                    <span className="text-2xl font-bold text-green-600">{formatCurrency(transaction.total)}</span>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>

                {/* Items Card */}
                {/* <div className="bg-white rounded-2xl shadow-xl mb-6">
                    <div className="p-6 border-b border-gray-100">
                        <div className="flex items-center gap-3">
                            <div className="bg-indigo-100 p-3 rounded-full">
                                <Package className="w-6 h-6 text-indigo-600" />
                            </div>
                            <h2 className="text-xl font-bold text-gray-800">Detail Produk</h2>
                        </div>
                    </div>

                    <div className="p-6">
                        <div className="space-y-4">
                            {transaction.items.map((item, index) => (
                                <div key={item.id} className="bg-gray-50 rounded-xl p-4 hover:bg-gray-100 transition-colors">
                                    <div className="flex justify-between items-start">
                                        <div className="flex-1">
                                            <h3 className="font-semibold text-gray-800 text-sm">{item.product_name}</h3>
                                            <p className="text-sm text-gray-500 mb-2">Kode: {item.product_code}</p>
                                            <div className="flex items-center gap-4 text-sm text-gray-600">
                                                <span>Qty: {item.quantity}</span>
                                                <span>@{formatCurrency(item.unit_price)}</span>
                                            </div>
                                        </div>
                                        <div className="text-right">
                                            <p className="text-sm font-bold text-gray-800">
                                                {formatCurrency(item.total_price)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div> */}

                {/* Summary Card */}
                {/* <div className="bg-white rounded-2xl shadow-xl">
                    <div className="p-6 border-b border-gray-100">
                        <div className="flex items-center gap-3">
                            <div className="bg-green-100 p-3 rounded-full">
                                <Receipt className="w-6 h-6 text-green-600" />
                            </div>
                            <h2 className="text-xl font-bold text-gray-800">Ringkasan Pembayaran</h2>
                        </div>
                    </div>

                    <div className="p-6">
                        <div className="space-y-4">
                            <div className="flex justify-between items-center py-2">
                                <span className="text-gray-600">Subtotal</span>
                                <span className="font-semibold">{formatCurrency(transaction.subtotal)}</span>
                            </div>

                            {transaction.discount > 0 && (
                                <div className="flex justify-between items-center py-2">
                                    <span className="text-gray-600">Diskon</span>
                                    <span className="font-semibold text-red-600">-{formatCurrency(transaction.discount)}</span>
                                </div>
                            )}

                            {transaction.tax > 0 && (
                                <div className="flex justify-between items-center py-2">
                                    <span className="text-gray-600">Pajak</span>
                                    <span className="font-semibold">{formatCurrency(transaction.tax)}</span>
                                </div>
                            )}
                        </div>
                    </div>
                </div> */}

                {/* Back Button */}
                {/* <div className="mt-8 text-center">
                    <button
                        onClick={() => window.history.back()}
                        className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-8 py-3 rounded-xl font-semibold hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
                    >
                        Kembali
                    </button>
                </div> */}
            </div>
        </div>
    );
};

export default OrderStatus;